import PhotoPreview from './PhotoPreview';
export default PhotoPreview;



// WEBPACK FOOTER //
// ./components/photo-preview/index.tsx